import React, { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { RotateLoader } from "react-spinners";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";

import { AuthContext } from "../../context/main/auth-context";
import "../../css/orders/orders.css";

import OrderListItemsBolShipStep2 from "../../components/bol/order-list-item-bol-ship-step-2";
import AssistantToggleButton from "../../components/main/assistant-toggle-button";
import getMultipleShippingLabelsPdfPostNL from "../../components/bol/get-multiple-shipping-labels-pdf-postnl";
import shipOrderItem from "../../components/bol/ship-order-item";

// Map lokale transportercodes -> wat Bol verwacht
const mapTransporterCodeForBol = (code) => {
  const map = {
    POSTNL_2928: "TNT",
    POSTNL_3085: "TNT",
    TNT_BRIEF: "TNT_BRIEF",
  };
  return map[code] || code;
};

const OrdersFbrDbrStep2 = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [loadingState, setLoadingState] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [checkedOrders, setCheckedOrders] = useState([]);

  // total items for UI/progress
  const totalItems = useMemo(() => {
    return checkedOrders.reduce(
      (acc, o) => acc + (o?.frontEndChosenDeliveryOption?.orderItems?.length || 0),
      0
    );
  }, [checkedOrders]);

  useEffect(() => {
    try {
      const checked = JSON.parse(sessionStorage.getItem("checkedOrders") || "[]");
      if (!checked || checked.length === 0) {
        setErrorMessage("Geen bestellingen gevonden");
        return;
      }
      // Gebruik een diepe kopie om mutatie van session copy te vermijden
      const clone = JSON.parse(JSON.stringify(checked));
      setCheckedOrders(clone);
    } catch (e) {
      setErrorMessage("Kon de selectie niet laden.");
    }
  }, []);

  const returnToStep1Handler = () => {
    navigate("/orders/bol/fbr/dbr/ship/step-1");
    window.scrollTo(0, 0);
  };

  const confirmToStep3Handler = async () => {
    if (!checkedOrders.length || totalItems === 0) {
      setErrorMessage("Geen geselecteerde bestelregels om te verwerken.");
      return;
    }

    setErrorMessage("");
    setLoadingState("Verzendlabels worden opgehaald...");

    // 1) Labels ophalen voor alle NIET-briefpost zendingen
    const ordersForLabels = checkedOrders.filter(
      (order) => order?.frontEndChosenDeliveryOption?.transporterCode !== "TNT_BRIEF"
    );

    let labelsPdf = null;

    console.log("Orders voor labels:", ordersForLabels);
    try {
      if (ordersForLabels.length > 0) {
        labelsPdf = await getMultipleShippingLabelsPdfPostNL(ordersForLabels, auth.token);
        console.log(labelsPdf,'ssssss');
        const ok =
          labelsPdf &&
          Array.isArray(labelsPdf.ResponseShipments) &&
          labelsPdf.ResponseShipments.length === ordersForLabels.length;

        if (!ok) {
          setErrorMessage("Er is iets misgegaan bij het ophalen van verzendlabels. Probeer het opnieuw.");
          setLoadingState("");
          return;
        }

        // Koppel labels aan orders (index-1-op-1; als jij een id meegeeft in je label request, koppel op id!)
        ordersForLabels.forEach((order, i) => {
          const labelData = labelsPdf.ResponseShipments[i];
          order.shipmentPostNL = labelData;
          order.frontEndChosenDeliveryOption.inputTrackAndTrace = labelData?.Barcode;
          order.inputTrackAndTrace = labelData?.Barcode;
        });
      }
    } catch (e) {
      setErrorMessage("Labels ophalen is mislukt.");
      setLoadingState("");
      return;
    }

    // 2) Shippen bij Bol met progress
    let processed = 0;
    setLoadingState(`0/${totalItems} bestelregels verwerkt...`);

    // Werk op een nieuwe kopie van orders (we willen sessionStorage na afloop schrijven)
    const ordersToProcess = JSON.parse(JSON.stringify(checkedOrders));

    for (const order of ordersToProcess) {
      if (!order?.frontEndChosenDeliveryOption) continue;

      // --- Stealth: wordt TNT_BRIEF zonder T&T ---
      const code = order.frontEndChosenDeliveryOption.transporterCode;
      if (code === "POSTNL_2928_STEALTH") {
        order.frontEndChosenDeliveryOption.transporterCode = "TNT_BRIEF";
        order.inputTrackAndTrace = undefined;
        order.frontEndChosenDeliveryOption.inputTrackAndTrace = undefined;
      } else {
        // Normale mapping
        order.frontEndChosenDeliveryOption.transporterCode = mapTransporterCodeForBol(code);
      }

      const account = order?.origin?.account;
      if (!account) {
        // Zonder account kunnen we niets shippen; markeer en ga door
        (order.frontEndChosenDeliveryOption.orderItems || []).forEach((it) => {
          it.shippedSuccesful = false;
        });
        continue;
      }

     for (const item of order.frontEndChosenDeliveryOption.orderItems || []) {
  try {
    item.shippedSuccesful = false;

    // Bouw extra payload voor backend
    const payload = {
      transporterCode: order.frontEndChosenDeliveryOption.transporterCode, // na mapping/stealth
      trackAndTrace: order.inputTrackAndTrace || undefined,               // undefined bij stealth
      // Alles wat we van PostNL terugkregen (barcode, pdf base64, etc.)
      shipmentPostNL: order.shipmentPostNL || null,
      ownReference: order.inputOwnReference || undefined,
      // Handige extra's
      orderId: order.orderId,
      orderDbId: order._id, // helpt bij exact matchen in DB
      orderItemId: item.orderItemId,
      ean: item?.product?.ean,
      sku: item?.product?.productData?.sku,
      quantity: item?.quantity || 1,
    };

    const res = await shipOrderItem(account, auth, order, item, payload);
    if (res?.ok && (res.status === 202 || res.status === 200)) {
      item.shippedSuccesful = true;
    }
  } catch (e) {
    item.shippedSuccesful = false;
  } finally {
    processed++;
    setLoadingState(`${processed}/${totalItems} bestelregels verwerkt...`);
  }
}

    }

    // 3) Opslaan en door
    try {
      if (labelsPdf) {
        sessionStorage.setItem("labelsPDF", JSON.stringify(labelsPdf));
      }
      sessionStorage.setItem("checkedOrders", JSON.stringify(ordersToProcess));
    } catch (e) {
      // Als sessionStorage vol/ongeldig is
      console.warn("Kon sessionStorage niet bijwerken", e);
    }

    setLoadingState("");
    navigate("/orders/bol/fbr/dbr/ship/step-3");
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <div className="title-header title-header-ship-orders">
        <span>Verzenden van bestellingen</span>
        <div className="shipmentSteps">
          <div className="shipmentOneStep shipmentFirstStep finished">
            <div className="shipmentOneStepCircle">1</div>
            <div>Verzendmethode</div>
          </div>
          <div className="shipmentStepsLine"></div>
          <div className="shipmentOneStep finished">
            <div className="shipmentOneStepCircle">2</div>
            <div>Overzicht</div>
          </div>
          <div className="shipmentStepsLine"></div>
          <div className="shipmentOneStep notActive">
            <div className="shipmentOneStepCircle">3</div>
            <div>Bevestiging</div>
          </div>
        </div>
      </div>

      {errorMessage && <div className="errorMessageField">{errorMessage}</div>}

      {checkedOrders.map((order, index) => (
        <OrderListItemsBolShipStep2 order={order} index={index} key={order.orderId || index} />
      ))}

      <div className="orders-container-footer-actions ship-orders-container-footer-actions step2">
        <Button className="previousBtn" onClick={returnToStep1Handler}>
          <GrLinkPrevious /> Vorige stap
        </Button>
        <Button
          className="nextBtn"
          onClick={confirmToStep3Handler}
          disabled={!checkedOrders.length || totalItems === 0 || !!loadingState}
        >
          Verwerken <GrLinkNext />
        </Button>
      </div>

      {loadingState && (
        <div className="loading-container">
          <div className="loading-container-title">{loadingState}</div>
          <RotateLoader size={100} width={100} height={10} color={"#fff"} loading />
        </div>
      )}

      <AssistantToggleButton />
    </div>
  );
};

export default OrdersFbrDbrStep2;
